import type { FeedbackSeverity } from '@feedback-system/types';

const SEVERITY_COLORS: Record<FeedbackSeverity, string> = {
  low: 'bg-accent-green/20 text-accent-green',
  medium: 'bg-accent-orange/20 text-accent-orange',
  high: 'bg-accent-orange_bright/20 text-accent-orange_bright',
  critical: 'bg-accent-red/20 text-accent-red',
};

export function SeverityBadge({ severity }: { severity: FeedbackSeverity }) {
  return (
    <span className={`badge ${SEVERITY_COLORS[severity]}`}>
      {severity.charAt(0).toUpperCase() + severity.slice(1)}
    </span>
  );
}
